module.exports = __webpack_public_path__ + "img/msg.1cfc6dd8.png";